import * as Configuration from 'src/ajs-app/app.constants.js';
import { CapabilityIdEnum } from 'src/app/shared/capabilities-and-permissions';

AlcSidenavController.$inject = ['$scope',
  '$rootScope',
  '$state',
  '$timeout',
  'UserFactory',
  'MetricCategoryHelperFactory',
  'NotificationsFactory',
  'TopToolbarFactory',
  'loggedUser',
  'company',
  'careMetrics',
  'LoginFactory',
  'MetricsFactory',
  'marketingMetrics',
  'AngularAlcmeonContextService'];
export function AlcSidenavController($scope,
  $rootScope,
  $state,
  $timeout,
  UserFactory,
  MetricCategoryHelperFactory,
  NotificationsFactory,
  TopToolbarFactory,
  loggedUser,
  company,
  careMetrics,
  LoginFactory,
  MetricsFactory,
  marketingMetrics,
  AngularAlcmeonContextService) {

  $scope.logoutClicked = logoutClicked;
  $scope.expandNavAfterDelay = expandNavAfterDelay;
  $scope.shrinkNavAfterDelay = shrinkNavAfterDelay;
  $scope.toggleNav = toggleNav;
  $scope.openNotifications = openNotifications;
  $scope.onSidenavDropdownClick = onSidenavDropdownClick;
  $scope.onSidenavDropdownClose = onSidenavDropdownClose;
  $scope.onSidenavDropdownChange = onSidenavDropdownChange;

  const savedStateForCareAndMarketing = {
    'blue': null,
    'orange': null
  };

  init();

  function openNotifications() {
    NotificationsFactory.openNotifications();
  }

  function updateSelectedItem(stateName) {
    let didSelectAnItem = false;
    for (let item of $scope.paramsPrefsAndLogout) {
      didSelectAnItem |= maybeUpdateSelectedState(item, stateName);
    }
    for (let section of $scope.navSections) {
      for (let item of section.items) {
        didSelectAnItem |= maybeUpdateSelectedState(item, stateName);
      }
    }
    if (!didSelectAnItem) {
      TopToolbarFactory.clearFirstLevelNavTranslation($scope);
    }
  }

  function maybeUpdateSelectedState(item, stateName) {
    item.isSelected = item.isSelectedFn(stateName);
    // Use this mechanism to check the disabled property.
    item.isDisabled = item.isDisabledFn && item.isDisabledFn(stateName);
    if (item.isSelected) {
      TopToolbarFactory.setFirstLevelNavTranslation(item.label, $scope);
    }
    return item.isSelected;
  }

  let timeoutPromise = null;

  function cancelPreviousTimeoutAndSetTimeout(fn, delay) {
    if (timeoutPromise != null) {
      // cancel any pending expand/shrink, so that the nav doesn't open and close indefinitely in some cases
      $timeout.cancel(timeoutPromise);
    }
    timeoutPromise = $timeout(() => {
      timeoutPromise = null;
      fn();
    }, delay);
  }

  function expandNavAfterDelay() {
    cancelPreviousTimeoutAndSetTimeout(expandNav, 300);
  }

  function shrinkNavAfterDelay() {
    cancelPreviousTimeoutAndSetTimeout(shrinkNav, 10); // There could as well be no delay but we definitely need to cancel any pending timeout
  }

  function toggleNav() {
    if ($scope.sideNavCssClass === '') {
      shrinkNavAfterDelay();
    } else {
      cancelPreviousTimeoutAndSetTimeout(expandNav, 10);
    }
  }

  function expandNav() {
    // let's not expand if the side bar is already open, as this will make its content blink
    if ($scope.sideNavCssClass !== '') {
      TopToolbarFactory.setSideNavOpener(false, $scope);
      $scope.sideNavCssClass = 'expanding_step1';
      cancelPreviousTimeoutAndSetTimeout(() => {
        $scope.sideNavCssClass = 'expanding_step2';
        cancelPreviousTimeoutAndSetTimeout(() => {
          $scope.sideNavCssClass = '';
        }, 50); // arbitrary delay to let the browser remove .only-when-expanded's 'display: none' (otherwise it could optimize out the opacity transition)
      }, 100); // must match md-sidenav's width transition-duration while expanding (in core.scss)
    }
  }

  function shrinkNav() {
    // let's not shrink if the side bar is already narrow, as this will briefly reopen it
    // (this will be the case after a click on a nav item)
    if ($scope.sideNavCssClass !== 'narrow' && !$scope.sidenavDropdownOpen) {  // 
      TopToolbarFactory.setSideNavOpener(true, $scope);
      $scope.sideNavCssClass = 'shrinking_step1';
      cancelPreviousTimeoutAndSetTimeout(() => {
        $scope.sideNavCssClass = 'shrinking_step2';
        cancelPreviousTimeoutAndSetTimeout(() => {
          $scope.sideNavCssClass = 'narrow';
        }, 50); // arbitrary delay to let the browser set .only-when-expanded display to 'none' (otherwise the width transition could start with them still displayed)
      }, 50); // must match .only-when-expanded's opacity transition-duration while shrinking (in core.scss)  
    }
  }

  function logoutClicked() {
    LoginFactory.logout(company);
    shrinkNav();
  }

  function inboxClicked() {
    // In push mode, prevent to refresh the inbox if user already on this one.
    if (loggedUser.is_in_push_mode === 1 && $state.current.name === 'auth.alcmeon.pushbox') {
      return;
    }
    $state.go('auth.alcmeon.after-login');
    shrinkNav();
  }

  function hrefForInbox() {
    const stateName = loggedUser.is_in_push_mode === 1 ? 'auth.alcmeon.pushbox' : 'auth.alcmeon.inbox.list.tasks';
    const stateParams = {
      siteId: 0
    };
    return hrefForState(stateName, stateParams);
  }

  function publishedClicked() {
    $state.go('auth.alcmeon.fuse.publications');
    shrinkNav();
  }

  function publishHref() {
    const stateName = 'auth.alcmeon.fuse.publications';
    return hrefForState(stateName);
  }

  function routeToState(stateName) {
    $state.go(stateName);
    shrinkNav();
  }

  function hrefForState(stateName, stateParams) {
    if (!stateParams) {
      stateParams = {};
    }
    if (!stateParams.companyId) {
      stateParams.companyId = company.id;
    }
    return Configuration.constants.frontendBaseUrl + $state.href(stateName, stateParams);
  }

  function routeToMetricCategory(categoryId, navigationMode) {
    const stateName = MetricsFactory.getMetricsReportStateForMode(navigationMode) + '.metrics';
    MetricCategoryHelperFactory.routeToBestEffortMetric($scope.metrics, categoryId, stateName);
    shrinkNav();
  }

  function hrefForMetricCategory(categoryId) {
    const stateName = MetricsFactory.getMetricsReportStateForMode($scope.navigationMode) + '.metrics-category';
    const stateParams = {
      category: categoryId
    };
    return hrefForState(stateName, stateParams);
  }

  function isMetricCategorySelected(categoryId, stateName, navigationMode) {
    const metricsReportsState = MetricsFactory.getMetricsReportStateForMode(navigationMode);
    const cateogrySet = MetricCategoryHelperFactory.getSelectedCategoryId(); // is only set after the init, by the metrics.controller
    return (stateName.startsWith(metricsReportsState + '.metrics')
      || stateName.startsWith('auth.alcmeon.fuse.verbatim'))
      && stateName !== metricsReportsState + '.metric-reports'
      && (cateogrySet === null || categoryId === cateogrySet)
  }

  function buildNavSections() {

    const navSections = [];

    if ($scope.selectedSidenav === 'blue') {   // 'Care' mode
      maybeAddMessagesNavSection(navSections);
      maybeAddAutomationNavSection(navSections);
      maybeAddAnalyticsNavSection(navSections);
    } else {                                   // 'Marketing' mode
      addMarketingSection(navSections);
      maybeAddAnalyticsSectionForMarketing(navSections);
    }

    return navSections;
  }


  function addMarketingSection(navSections) {
    const marketingSection = new NavSection('sidenav/campaigns');

    marketingSection.items.push(new NavItem(
      'audience/title',
      'contacts',
      stateName => stateName.startsWith('auth.alcmeon.fuse.audience'),
      () => routeToState('auth.alcmeon.fuse.audience'),
      hrefForState('auth.alcmeon.fuse.audience'))
    );
    marketingSection.items.push(new NavItem(
      'segments',
      'my_location',
      stateName => stateName.startsWith('auth.alcmeon.fuse.segments'),
      () => routeToState('auth.alcmeon.fuse.segments'),
      hrefForState('auth.alcmeon.fuse.segments'))
    );
    marketingSection.items.push(new NavItem(
      'optins/title',
      'check_circle',
      stateName => stateName.startsWith('auth.alcmeon.fuse.optins'),
      () => routeToState('auth.alcmeon.fuse.optins'),
      hrefForState('auth.alcmeon.fuse.optins'),
      'optins'
    ),
    );
    marketingSection.items.push(new NavItem(
      'sidenav/campaign-scenarios',
      'device_hub',
      stateName => stateName.includes('campaign-scenarios'),
      () => routeToState('auth.alcmeon.fuse.parameters.all-accounts.campaign-scenarios'),
      hrefForState('auth.alcmeon.fuse.parameters.all-accounts.campaign-scenarios'),
      'scenarios'
    ),
    );
    marketingSection.items.push(new NavItem(
      'sidenav/automation/sat',
      'insert_emoticon',
      stateName => stateName.includes('.marketing-satisfaction-surveys'),
      () => routeToState('auth.alcmeon.fuse.parameters.all-accounts.marketing-satisfaction-surveys'),
      hrefForState('auth.alcmeon.fuse.parameters.all-accounts.marketing-satisfaction-surveys'),
      'surveys')
    );
    marketingSection.items.push(new NavItem(
      'mass_messaging_list/title',
      'volume_up',
      stateName => stateName.startsWith('auth.alcmeon.fuse.mass-messaging'),
      () => routeToState('auth.alcmeon.fuse.mass-messaging'),
      hrefForState('auth.alcmeon.fuse.mass-messaging'))
    );
    navSections.push(marketingSection);
  }

  function maybeAddAnalyticsSectionForMarketing(navSections) {
    // If the user has capabilities for statistics, addd an analytics section
    if (UserFactory.hasCapabilityForAtLeastOneEnabledSite(CapabilityIdEnum.Statistics)) {
      const analyticsSection = new NavSection('sidenav/analytics');
      const volumeId = 'metrics/category/volume';
      analyticsSection.items.push(new NavItem(
        volumeId,
        'horizontal_split',
        stateName => isMetricCategorySelected(volumeId, stateName, 'marketing'),
        () => routeToMetricCategory(volumeId, 'marketing'),
        hrefForMetricCategory(volumeId))
      )
      const satisfactionId = 'metrics/category/statisfaction';
      analyticsSection.items.push(new NavItem(
        satisfactionId,
        'favorite_border',
        stateName => isMetricCategorySelected(satisfactionId, stateName, 'marketing'),
        () => routeToMetricCategory(satisfactionId, 'marketing'),
        hrefForMetricCategory(satisfactionId))
      )

      navSections.push(analyticsSection);
    }
  }


  function maybeAddAnalyticsNavSection(navSections) {
    if (UserFactory.hasCapabilityForAtLeastOneEnabledSite(CapabilityIdEnum.Statistics)) {

      const volumeId = 'metrics/category/volume';
      const deplaysId = 'metrics/category/delay';
      const satisfactionId = 'metrics/category/statisfaction';

      const analyticsSection = new NavSection('sidenav/analytics');

      analyticsSection.items.push(new NavItem(
        'parameters/links_menu/reports',
        'trending_up',
        stateName => stateName.startsWith('auth.alcmeon.fuse.metrics-and-reports.metric-reports')
          || stateName === 'auth.alcmeon.fuse.metrics-and-reports1.metric-reports',
        () => routeToState('auth.alcmeon.fuse.metrics-and-reports.metric-reports'),
        hrefForState('auth.alcmeon.fuse.metrics-and-reports.metric-reports')));

      analyticsSection.items.push(new NavItem(
        volumeId,
        'horizontal_split',
        stateName => isMetricCategorySelected(volumeId, stateName, 'care'),
        () => routeToMetricCategory(volumeId, 'care'),
        hrefForMetricCategory(volumeId)));

      analyticsSection.items.push(new NavItem(
        deplaysId,
        'timer',
        stateName => isMetricCategorySelected(deplaysId, stateName, 'care'),
        () => routeToMetricCategory(deplaysId, 'care'),
        hrefForMetricCategory(deplaysId)));

      analyticsSection.items.push(new NavItem(
        satisfactionId,
        'favorite_border',
        stateName => isMetricCategorySelected(satisfactionId, stateName, 'care'),
        () => routeToMetricCategory(satisfactionId, 'care'),
        hrefForMetricCategory(satisfactionId)));
      navSections.push(analyticsSection);
    }
  }


  function maybeAddAutomationNavSection(navSections) {
    if (UserFactory.hasCapabilityForAtLeastOneEnabledSite(CapabilityIdEnum.Automation)) {

      const automationSection = new NavSection('sidenav/automation');
      const triageState = 'auth.alcmeon.fuse.parameters.triage';

      automationSection.items.push(new NavItem(
        'sidenav/automation/chatbots',
        'question_answer',
        stateName => stateName.includes('.quick-replies'),
        () => routeToState('auth.alcmeon.fuse.parameters.all-accounts.quick-replies'),
        hrefForState('auth.alcmeon.fuse.parameters.all-accounts.quick-replies'),
        'chat-bots'));

      if (loggedUser.is_company_admin === 1) {
        automationSection.items.push(new NavItem(
          'sidenav/automation/triage',
          'call_merge',
          stateName => !!stateName.match(/triage/),
          () => routeToState(triageState),
          hrefForState(triageState)));
      }

      automationSection.items.push(new NavItem(
        'sidenav/automation/sat',
        'insert_emoticon',
        stateName => stateName.includes('.satisfaction-surveys'),
        () => routeToState('auth.alcmeon.fuse.parameters.all-accounts.satisfaction-surveys'),
        hrefForState('auth.alcmeon.fuse.parameters.all-accounts.satisfaction-surveys'),
        'surveys'));

      automationSection.items.push(new NavItem(
        'sidenav/automation/favorites',
        'star',
        stateName => stateName.includes('.favorites'),
        () => routeToState('auth.alcmeon.fuse.favorites'),
        hrefForState('auth.alcmeon.fuse.favorites'),
        'favorites'));

      navSections.push(automationSection);
    }
  }


  function maybeAddMessagesNavSection(navSections) {
    const showInboxAndSearch = UserFactory.hasCapabilityForAtLeastOneEnabledSite(CapabilityIdEnum.Answer);
    const hideSearch = loggedUser.is_in_push_mode === 1; // #3935
    const showPublish = UserFactory.hasCapabilityForAtLeastOneEnabledSite(CapabilityIdEnum.Publish);

    if (showInboxAndSearch || showPublish) {
      const messagesSection = new NavSection('sidenav/messages');

      if (showInboxAndSearch) {

        messagesSection.items.push(new NavItem(
          'sidenav/messages/inbox',
          'mail_outline',
          stateName => stateName.startsWith('auth.alcmeon.inbox')
            || stateName.startsWith('auth.alcmeon.pushbox'),
          inboxClicked,
          hrefForInbox(),
          'inbox-btn',
          (stateName) => stateName.startsWith('auth.alcmeon.pushbox')
        ));

        if (!hideSearch) {
          messagesSection.items.push(new NavItem(
            'sidenav/messages/search',
            'search',
            stateName => stateName.startsWith('auth.alcmeon.search'),
            () => routeToState('auth.alcmeon.search-legacy.tasks'),
            hrefForState('auth.alcmeon.search-legacy.tasks')));
        }
      }
      if (showPublish) {

        messagesSection.items.push(new NavItem(
          'sidenav/messages/publish',
          'send',
          stateName => stateName.startsWith('auth.alcmeon.fuse.publications'),
          publishedClicked,
          publishHref()));
      }
      if (AngularAlcmeonContextService.isEngagement() && UserFactory.hasCapabilityForAtLeastOneEnabledSite(CapabilityIdEnum.Engagement)) {
        const stateName = 'auth.alcmeon.engagement.history';
        messagesSection.items.push(new NavItem(
          'sidenav/engagement/history',
          'chat',
          currentStateName => stateName === currentStateName,
          () => {
            $state.go(stateName);
            shrinkNav();
          },
          hrefForState(stateName))
        )
      }

      navSections.push(messagesSection);
    }
  }


  function buildParamsPrefsAndLogout() {
    const paramsPrefsAndLogout = [];
    const showParameters = !!loggedUser.is_company_admin;
    if (showParameters) {
      paramsPrefsAndLogout.push(new NavItem(
        'menu/settings',
        'settings',
        stateName => (!stateName.includes('.quick-replies')
          && !stateName.includes('.satisfaction-surveys')
          && !stateName.includes('.campaign-scenarios')
          && (stateName.startsWith('auth.alcmeon.parameters')
            || stateName.startsWith('auth.alcmeon.fuse.parameters')
            || stateName.startsWith('auth.alcmeon.fuse.users-roles'))),
        () => routeToState('auth.alcmeon.fuse.parameters.accounts'),
        hrefForState('auth.alcmeon.fuse.parameters.accounts')));
    }

    paramsPrefsAndLogout.push(new NavItem(
      'menu/preferences',
      'account_circle',
      stateName => stateName.startsWith('auth.alcmeon.preferences'),
      () => routeToState('auth.alcmeon.fuse.preferences.account'),
      hrefForState('auth.alcmeon.fuse.preferences.account')));

    paramsPrefsAndLogout.push(new NavItem(
      'menu/logout',
      'power_settings_new',
      () => false,
      logoutClicked,
      '#',
      'logout-btn')); // Logout is js-only, as it must decide whether to open the « su » modal or logout directly

    return paramsPrefsAndLogout;
  }

  function onSidenavDropdownClick() {
    $scope.sidenavDropdownOpen = true;
  }
  function onSidenavDropdownClose() {
    $scope.sidenavDropdownOpen = false;
  }
  function onSidenavDropdownChange() {
    $scope.navigationMode = $scope.selectedSidenav === 'orange' ? 'marketing' : 'care';
    $scope.metrics = $scope.navigationMode === 'care' ? careMetrics : marketingMetrics;
    $scope.navSections = buildNavSections();
    const newSidenavId = $scope.selectedSidenav;
    const previousSideNavId = newSidenavId === 'blue' ? 'orange' : 'blue';
    savedStateForCareAndMarketing[previousSideNavId] = {
      stateName: $state.current.name,
      stateParams: angular.copy($state.params)
    };
    const savedState = savedStateForCareAndMarketing[newSidenavId];
    if (savedState) {
      $state.go(savedState.stateName, savedState.stateParams);
    } else {
      $scope.navSections[0].items[0].onClick();
    }
    TopToolbarFactory.setExtraClass($scope.selectedSidenav === 'orange' ? 'marketing' : '', $scope);

    updateSelectedItem($state.current.name);
  }

  function redirectToLoginPageIfSessionMatches(eventType, event) {
    if (loggedUser.session_id === event.session_id) {
      // This is the case where the user has many open sessions and one of them is closed
      const loginStateParams = {
        errorMessageKey: 'error/login-page-message/session-expired-or-invalid',
        companyName: company.url_name
      };
      $state.go('no-auth.company.login', loginStateParams);
    }
  }

  function init() {
    $scope.sideNavCssClass = 'narrow';

    // Different sidenav modes
    $scope.sidenavDropdownItems = [
      {
        id: 'blue',
        label: 'care',
        sortOrder: 1
      },
      {
        id: 'orange',
        label: 'marketing',
        sortOrder: 2
      }
    ];
    $scope.routeFound = false;  // Used for initially updating the sidenav

    // Display sidenav dropdown only if the user has at least one marketing capability 
    $scope.displaySidenavDropdown = UserFactory.hasCapabilityForAtLeastOneEnabledSite(CapabilityIdEnum.Marketing);

    // If the user follows a direct link update the sidenav appropriately
    if ($scope.displaySidenavDropdown) {
      $scope.selectedSidenav = 'orange';
      $scope.navigationMode = 'marketing';
      $scope.metrics = marketingMetrics;
      $scope.navSections = buildNavSections();

      // Check if the current route belongs in 'marketing' mode
      const navItems = $scope.navSections.flatMap(sec => sec.items);
      $scope.routeFound = navItems.some(item => item.isSelectedFn($state.current.name));
      /* Some routes are not matching the urls related the nav items for marketing mode. 
       * In this case check the state data if the flag is present.
       */
      if (!$scope.routeFound && $state.current.data) {
        $scope.routeFound = $state.current.data.isMarketingMode;
      }
    }
    if (!$scope.routeFound) {
      $scope.selectedSidenav = 'blue'; // Alcmeon 'answer' by default
      $scope.navigationMode = 'care';
      $scope.metrics = careMetrics;
      $scope.navSections = buildNavSections();
    }

    // Set the color of the toptoolbar to match the sidenav
    TopToolbarFactory.setExtraClass($scope.selectedSidenav === 'orange' ? 'marketing' : '', $scope);

    $scope.paramsPrefsAndLogout = buildParamsPrefsAndLogout();
    updateSelectedItem($state.current.name);
    const unsubscribeFn = $rootScope.$on('$stateChangeSuccess', (event, toState) => updateSelectedItem(toState.name));
    $scope.$on('$destroy', unsubscribeFn);

    // When the metric subnav changes the route, stateChangeSuccess notifs might arrive out of order in the handler just above;
    // that's why we need to call updateSelectedItem again when the metric subnav has selected a metric
    MetricCategoryHelperFactory.setUpdateSideNavFn(updateSelectedItem);

    //set up interaction with notifications controler
    $scope.unseenNotificationsCount = 0;
    NotificationsFactory.setUpdateUnseenNotificationsCountFn(
      count => $scope.unseenNotificationsCount = count
    );

    TopToolbarFactory.setExpandSideNavFn(() => expandNav());
    TopToolbarFactory.setSideNavOpener(true, $scope);
    TopToolbarFactory.setCompanyName(company.name, $scope);

    // Update the sortOrder of the modes (selected one should appear first in the dropdown)
    $scope.$watch('selectedSidenav', value => {
      $scope.sidenavDropdownItems[0].sortOrder = value === 'blue' ? 1 : 2;
      $scope.sidenavDropdownItems[1].sortOrder = value === 'blue' ? 2 : 1;
    });
    $rootScope.$on('ws.user.session-closed', redirectToLoginPageIfSessionMatches);
  }
}


class NavSection {
  constructor(title) {
    this.title = title;
    this.items = [];
  }
}


class NavItem {
  constructor(label, icon, isSelectedFn, onClickFn, href, testId, isDisabledFn) {
    this.label = label;
    this.icon = icon;
    this.isSelectedFn = isSelectedFn;
    this.onClick = onClickFn;
    this.href = href;
    this.testId = testId
    this.isDisabledFn = isDisabledFn
  }
}
